<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col :cols="this.$vuetify.breakpoint.mobile ? 12 : 8">
        <v-btn v-if="showCreatorControls" fab small absolute color="primary" @click.stop="showChallengeEditor = true"><v-icon>mdi-plus</v-icon></v-btn>
        <ChallengeEditor v-if="showChallengeEditor" v-on:dialog-close="showChallengeEditor=false" v-on:challenge-created="processNewCreatedChallenge($event)" />
        <v-tabs v-model="activeTab" fixed-tabs @change="updateChallengeList()">
          <v-tab>Races</v-tab>
          <v-tab>Time Trials</v-tab>
          <v-tab>Race History</v-tab>
          <v-tab v-if="isAuthorized('CONTENT_CREATOR')">Approval Requests</v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab" touchless>
          <v-tab-item><ChallengeList ref="raceList" challenge-type="RACE" :show-creator-controls="showCreatorControls" @noItems="activeTab=1"/></v-tab-item>
          <v-tab-item><ChallengeList ref="timeTrialList" challenge-type="TIME_TRIAL" :show-creator-controls="showCreatorControls"/></v-tab-item>
          <v-tab-item>
            <v-banner class="ma-5">Last 10 public races:</v-banner>
            <ChallengeList ref="publicRaceHistoryList" challenge-type="RACE" show-finished is-public-race-history @noItems="activeTab=0"/>
          </v-tab-item>
          <v-tab-item v-if="isAuthorized('CONTENT_CREATOR')"><ChallengeList ref="approvalRequestsList" @noItems="activeTab=0" show-approval-requests/></v-tab-item>
        </v-tabs-items>
      </v-col>
      <v-col v-if="!this.$vuetify.breakpoint.mobile" cols="4" class="mt-10">
        <div class="sticky-top">
          <v-spacer class="mt-10"></v-spacer>
          <WeatherCard></WeatherCard>
          <OnlineUsersCard></OnlineUsersCard>
          <GlobalLeaderboardCard></GlobalLeaderboardCard>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AuthMixin from "@/mixins/AuthMixin";
import ChallengeList from '../components/ChallengeList';
import GlobalLeaderboardCard from "../components/LeaderboardCard";
import WeatherCard from "../components/WeatherCard";
import OnlineUsersCard from "../components/OnlineUsersCard";
import ChallengeEditor from "@/components/admin/ChallengeEditor";

export default {
  name: 'Dashboard',
  components: {
    GlobalLeaderboardCard,
    ChallengeList,
    OnlineUsersCard,
    WeatherCard,
    ChallengeEditor
  },
  mixins: [
    AuthMixin
  ],
  data: () => ({
    activeTab: 0,
    showChallengeEditor: false
  }),
  computed: {
    activeChallengeList() {
      switch (this.activeTab) {
        case 0: return this.$refs.raceList
        case 1: return this.$refs.timeTrialList
        case 2: return this.$refs.publicRaceHistoryList
        case 3: return this.$refs.approvalRequestsList
        default: return null
      }
    },
    showCreatorControls() {
      return this.isAuthorized('SUPER_ADMIN')
    }
  },
  mounted() {
    this.activeTab = this.isAuthorized('CONTENT_CREATOR') ? 3 : 0
  },
  methods: {
    updateChallengeList() {
      if (this.activeChallengeList) this.activeChallengeList.updateChallengeList()
    },
    processNewCreatedChallenge(challenge) {
      let challengeList = null
      if (challenge.type === 'RACE') {
        this.activeTab = 0
        challengeList = this.$refs.raceList
      } else {
        this.activeTab = 1
        challengeList = this.$refs.timeTrialList
      }
      challengeList.updateChallengeList()
    }
  }
};
</script>

<style scoped>

.sticky-top {
  position: sticky;
  top: 6%;
}

</style>